<div class="tour-popover">
  <div class="tour-popover-arrow"></div>
  
  <div class="tour-popover-header" *ngIf="title">
    <h4 class="tour-popover-title">{{ title }}</h4>
    <button 
      class="tour-popover-close" 
      (click)="handleClose()"
      aria-label="Close popover">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="tour-popover-body" [innerHTML]="content"></div>

  <div class="tour-popover-footer" *ngIf="showNextButton">
    <button 
      class="tour-popover-next-btn" 
      (click)="handleNext()">
      Next Step
      <i class="fas fa-arrow-right ms-2"></i>
    </button>
  </div>
</div>
